export default __webpack_public_path__ + "static/media/CNo.83-2.c981f756.jpg";